import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const cookieConsent = localStorage.getItem("cookie_consent");
    if (!cookieConsent) {
      // Show banner after a small delay for better UX
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookie_consent", "accepted");
    localStorage.setItem("cookie_consent_date", new Date().toISOString());
    setIsVisible(false);
  };

  const declineCookies = () => {
    localStorage.setItem("cookie_consent", "declined");
    localStorage.setItem("cookie_consent_date", new Date().toISOString());
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 animate-in slide-in-from-bottom duration-500 pointer-events-none"
      data-testid="cookie-banner"
    >
      <div className="max-w-4xl mx-auto pointer-events-auto">
        <div className="bg-white rounded-2xl shadow-2xl border border-slate-200 p-6 md:p-8">
          <div className="flex flex-col md:flex-row gap-6 items-start md:items-center">
            {/* Icon & Text */}
            <div className="flex gap-4 flex-1">
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center flex-shrink-0">
                <Cookie className="w-6 h-6 text-blue-600" />
              </div>
              <div>
                <h3 className="font-semibold text-slate-900 mb-1">
                  Folosim cookie-uri 🍪
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed">
                  Utilizăm cookie-uri pentru a îmbunătăți experiența ta pe site. 
                  Cookie-urile esențiale sunt necesare pentru funcționarea platformei. 
                  Citește mai multe în{" "}
                  <Link 
                    to="/politica-cookies" 
                    className="text-blue-600 hover:underline font-medium"
                  >
                    Politica de Cookies
                  </Link>
                  .
                </p>
              </div>
            </div>

            {/* Buttons */}
            <div className="flex gap-3 w-full md:w-auto">
              <Button
                variant="outline"
                onClick={declineCookies}
                className="flex-1 md:flex-none border-slate-300 text-slate-700 hover:bg-slate-100"
              >
                Refuz
              </Button>
              <Button
                onClick={acceptCookies}
                className="flex-1 md:flex-none bg-blue-600 hover:bg-blue-700 text-white"
              >
                Accept cookie-urile
              </Button>
            </div>
          </div>

          {/* Links */}
          <div className="mt-4 pt-4 border-t border-slate-100 flex flex-wrap gap-4 text-sm text-slate-500">
            <Link to="/politica-confidentialitate" className="hover:text-blue-600 hover:underline">
              Politica de Confidențialitate
            </Link>
            <Link to="/termeni-conditii" className="hover:text-blue-600 hover:underline">
              Termeni și Condiții
            </Link>
            <Link to="/politica-cookies" className="hover:text-blue-600 hover:underline">
              Politica de Cookies
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
